<template>
  <div id="index">
    <!-- header -->
    <div class="header">
      <!-- 文字 -->
      <div
        style="
          font-size: 22px;
          margin-left: 2%;
          display: block;
          position: absolute;
          top: 50%;
          margin-top: -18px;
          color: #1b75d5;
        "
      >
      乐山知识产权数据分析平台
      </div>
      <!-- 右 -->
      <div
        style="
          display: flex;
          position: absolute;
          right: 34px;
          top: 32%;
          font-size: 16px;
        "
      >
        <div style="margin-right: 97px">
          <i class="iconfont" style="margin-right: 7px">&#xe6b0;</i
          >欢迎您：<span style="color: #1471d5"> {{ uName }}</span>
        </div>
        <div @click="exitSys" style="cursor: pointer">
          <i class="iconfont" style="margin-right: 7px">&#xe6b9;</i>退出系统
        </div>
      </div>
    </div>
    <!-- content -->
    <div style="display: flex; width: 100vw; min-width: 1366px">
      <!-- 侧边栏 -->

      <div class="asideBar">
        <el-row class="tac">
          <el-col :span="12">
            <el-menu
              :default-active="activerouter"
              :router="true"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              background-color="#1a2737"
              text-color="#fff"
              unique-opened
            >
              <router-link :to="{ name: 'HomeOverview' }">
                <el-menu-item index="homeoverview">
                  <i class="iconfont iconStyle">&#xe6bb;</i>
                  <span slot="title"> 首页概况 </span>
                </el-menu-item>
              </router-link>
        
              <el-submenu index="1" v-if="funcId.indexOf('16') > -1">
                <template slot="title">
                  <i class="iconfont iconStyle">&#xe6b2;</i>

                  <span>企业管理</span>
                </template>
                <router-link :to="{ name: 'EnterpriseSearch' }">
                  <el-menu-item
                    index="enterprisesearch" 
                    
                    >企业查询</el-menu-item
                  >
                </router-link>
                <!-- <router-link :to="{ name: 'KeyCompanies' }">
                  <el-menu-item index="keycompanies"
                    >企业分析</el-menu-item
                  >
                </router-link> -->
              </el-submenu>
              

              <el-submenu index="2" v-if="funcId.indexOf('18') > -1 || funcId.indexOf('19') > -1  ">
                <template slot="title">
                  <i class="iconfont iconStyle">&#xe6b8;</i>

                  <span>专利管理</span>
                </template>
                <router-link :to="{ name: 'PatentsSearch' }" >
                  <el-menu-item
                    index="patentssearch" v-if="funcId.indexOf('18') > -1 "
                    
                    >专利查询</el-menu-item
                  >
                </router-link>
                <router-link :to="{ name: 'PatentAnalysis' }">
                  <el-menu-item
                    index="patentanalysis" v-if="funcId.indexOf('19') > -1"
                    
                    >专利分析</el-menu-item
                  >
                </router-link>
              </el-submenu>

              <el-submenu index="3" v-if="funcId.indexOf('20') > -1 || funcId.indexOf('21') > -1  ">
                <template slot="title">
                  <i class="iconfont iconStyle">&#xe6b1;</i>
                  <span>商标管理</span>
                </template>
                <router-link :to="{ name: 'TrademarkSearch' }">
                  <el-menu-item index="trademarksearch" v-if="funcId.indexOf('20') > -1">商标查询</el-menu-item>
                </router-link>
                <router-link :to="{ name: 'TrademarkAnalysis' }">
                  <el-menu-item index="trademarkanalysis" v-if="funcId.indexOf('21')  > -1 "
                    >商标分析</el-menu-item
                  >
                </router-link>
              </el-submenu>

              <!-- <router-link :to="{ name: 'KeyIndustries' }"> -->
                <!-- <el-menu-item index="KeyIndustries" v-if="funcId.indexOf('24')  > -1 ">
                  <i class="iconfont iconStyle">&#xe6b6;</i>
                  <span slot="title">重点产业分析</span>
                </el-menu-item> -->
              <!-- </router-link> -->
              <router-link :to="{ name: 'ReportManagement' }">
                <el-menu-item index="reportManagement" v-if="funcId.indexOf('30')  > -1 ">
                  <i class="iconfont iconStyle">&#xe6bc;</i>
                  <span slot="title">报告管理</span>
                </el-menu-item>
              </router-link>
              <el-submenu index="6" v-if="funcId.indexOf('26') > -1 || funcId.indexOf('25') > -1  ">
                <template slot="title">
                  <i class="iconfont iconStyle">&#xe6ba;</i>
                  <span>地理标志</span>
                </template>
                <router-link :to="{ name: 'GeoTrademark' }">
                  <el-menu-item index="geotrademark"  v-if="funcId.indexOf('26')  > -1 "
                    >地标商标管理</el-menu-item
                  >
                </router-link>
                <router-link :to="{ name: 'GeoProducts' }">
                  <el-menu-item index="geoproducts"  v-if="funcId.indexOf('25')  > -1"
                    >地标产品管理</el-menu-item
                  >
                </router-link>
              </el-submenu>
              <!-- <router-link :to="{ name: 'IntegratedDiagram' }">
                <el-menu-item index="integratedDiagram" v-if="funcId.indexOf('29')  > -1 " >
                  <i class="iconfont iconStyle">&#xe6b4;</i>
                  <span slot="title">集成电路布图设计</span>
                </el-menu-item>
              </router-link> -->
              <!-- <el-submenu index="4" v-if="funcId.indexOf('22') > -1 || funcId.indexOf('23') > -1 ">
                <template slot="title">
                  <i class="iconfont iconStyle">&#xe6b7;</i>

                  <span>续期预警</span>
                </template>
                <router-link :to="{ name: 'RenewalAlertpt' }">
                  <el-menu-item index="renewalalertpt" v-if="funcId.indexOf('22') > -1 ">专利预警</el-menu-item>
                </router-link>
                <router-link :to="{ name: 'RenewalAlerttm' }">
                  <el-menu-item index="renewalalerttm" v-if="funcId.indexOf('23') > -1">商标预警</el-menu-item>
                </router-link>
              </el-submenu> -->

              <!-- <el-submenu index="7"  v-if="funcId.indexOf('27') > -1 || funcId.indexOf('28') > -1">
                <template slot="title">
                  <i class="iconfont iconStyle">&#xe6b5;</i>
                  <span>系统设置</span>
                </template> -->
                <router-link :to="{ name: 'UserManage' }">
                  <el-menu-item index="usermanage" v-if="funcId.indexOf('27') > -1">
                    <i class="iconfont iconStyle">&#xe6b5;</i>
                    <span>用户管理</span>
                  </el-menu-item>
                </router-link>
                <router-link :to="{ name: 'serviceAdvice' }">
                  <el-menu-item index="advice" v-if="funcId.indexOf('31') > -1">
                    <i class="iconfont iconStyle">&#xe6b7;</i>
                    <span>服务咨询</span>
                  </el-menu-item>
                </router-link>
                <!-- <router-link :to="{ name: 'WarningSettings' }">
                  <el-menu-item index="warningsettings" v-if="funcId.indexOf('28') > -1 ">预警设置</el-menu-item>
                </router-link> -->
              <!-- </el-submenu> -->
             
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <!-- 内容（切换   子路由） -->

      <!-- <keep-alive> -->

      <div class="childContent">
        <keep-alive
          include="tdemarkSearch,patSearch,enterPriseSearch,reportManage"
        >
          <router-view></router-view>
        </keep-alive>
      </div>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      func: this.$store.state.FuncPermission,
      funcId: [],
     
      uName: localStorage.getItem("uName"),
      uid: localStorage.getItem("uid"),
      acheck: 12,
      activerouter: "homeoverview",
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },

    exitSys() {
      const uid = { uid: this.uid };
      // console.log('-----', uid)
      this.$get("/user/logout", uid).then((res) => {
        if (res.status == 200) {
          // console.log('---',res)
          localStorage.setItem("token", "");
          localStorage.clear();
          // this.$router.back();
          this.$router.push('/login')
        }
      });
    },

    aCheck(val) {
      this.acheck = val;
    },
  },
  mounted() {
    // 功能权限编号
    this.func.forEach((element) => {
      this.funcId.push(element.id);
    });
    // console.log("func", this.func);
   
    let arr = window.location.href.split("/");
    this.activerouter = arr[arr.length - 1];
  },
};
</script>
<style>
#index .header {
  width: 100vw;
  height: 4.5vh;
  min-width: 1366px;
  min-height: 50px;
  background: #fff;
  display: flex;
  position: relative;
}
#index .asideBar {
  padding-top: 14px;
  width: 13%;
  min-width: 160px;
  height: 90.5vh;
  min-height: 700px;
  background: #1a2737;
}
#index .childContent {
  width: 90.7%;
  background: #f2f2f2;
}
#index .tac .el-col-12 {
  width: 100%;
}
#index a {
  color: #fff;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
#index .el-submenu__title {
  background: #1a2737 !important;
  font-size: 16px !important;
}
#index .el-menu {
  border-right: 0;
}
#index .el-submenu .el-menu-item {
  min-width: 0 !important;
}
#index .el-menu-item {
  background: #1a2737 !important;
  font-size: 16px !important;
}

#index .el-submenu__title i {
  color: #f3f7fa !important;
}

#index .el-menu-item:hover,
#index .el-submenu:hover,
#index .el-submenu__title:hover {
  background: #000000 !important;
  /* color: #1B75D5 !important; */
}

#index .el-menu-item.is-active {
  background: #fff !important;
  color: #1b75d5 !important;
  border-right: 8px solid #1b75d5;
}
.el-menu-item.is-active i {
  color: #1b75d5 !important;
}

#index .childContent {
  position: relative;
}
.iconStyle {
  margin-right: 10px;
  margin-left: 2px;
  color: #fff !important;
}
</style>